import { MENU_DATA_ATTR } from './components/menu/constants';
import StoreStatus from './components/storeHours/storeStatus';
import { getUserEnteredZipCode } from './storage/cookie';
import { getStoreStatusDisplay, isClosed, Store, StoreAvailability } from './types/store';
import * as environment from './utils/environment';
import { determineSeeCarsUrl } from './utils/search';

export const links = {
    appointments: {
        text: 'My appointments',
        href: '/mycarmax/appointments'
    },
    appraisals: {
        text: 'Appraisals',
        href: '/mycarmax/appraisals'
    },
    faq: {
        text: 'FAQ',
        href: '/faq'
    },
    helpCenter: {
        text: 'FAQ &amp; support',
        href: '/help-center'
    },
    buyingOnline: {
        text: 'Buying online',
        href: '/buying-online'
    },
    makeAPayment: {
        text: 'Make a payment',
        href: `${environment.getCAFBaseUrl()}/account/summary`
    },
    maxcareService: {
        text: 'Warranties &amp; MaxCare&NoBreak;&#174;',
        href: '/car-buying-process/maxcare-service-plans'
    },
    careers: {
        text: 'Search jobs at CarMax',
        href: 'https://careers.carmax.com/us/en/'
    },
    getAnOnlineOffer: {
        text: 'Get an online offer',
        href: '/sell-my-car'
    },
    getPreQualified: {
        text: 'Get pre-qualified',
        href: '/pre-qual/app?op=global_footer'
    },
    sellHowItWorks: {
        text: 'How it works',
        href: '/sell-my-car#how-it-works'
    },
    financeHowItWorks: {
        text: 'How it works',
        href: '/car-financing'
    },
    findAStore: {
        text: 'Find a store',
        href: '/stores'
    },
    carMaxAutoFinance: {
        text: 'CarMax AutoFinance',
        href:'/car-financing/carmax-auto-finance'
    },
    myDashboard: {
        text: 'My dashboard',
        href: '/hub/dashboard'
    },
    myOrders: {
        text: 'My orders',
        href: '/checkout'
    },
    profileSettings: {
        text: 'Profile settings',
        href: '/hub/profile-settings'
    },
    researchArticles: {
        text: 'Car research &amp; advice',
        href: '/research'
    },
    researchEVGuide: {
        text: 'Guide to EVs',
        href: '/research/electric-vehicle-guide'
    },
    savedCars: {
        text: 'My favorites',
        href: '/mycarmax/saved-cars'
    },
    savedSearches: {
        text: 'My saved searches',
        href: '/mycarmax/saved-searches'
    },
    service: {
        text: 'Service &amp; repairs',
        href: '/service'
    },
    signIn: {
        text: 'Sign in or create account',
        href: `/mycarmax/sign-in?returnUrl=${encodeURIComponent(window.location.href)}`
    },
    signOut: {
        text: 'Sign out',
        href: '/mycarmax/sign-out'
    },
    viewAllInventory: {
        text: 'View all inventory',
        href: '/cars/all'
    },
    watchlist: {
        text: 'Your favorites',
        href: '/watchlist'
    },
    whyCarMax: {
        text: 'Why CarMax',
        href: '/why-carmax'
    }
};

export const icons = {
    buildDropdownIcon: (classes?: string) =>
        `<svg ${
            classes ? `class="${classes}"` : ''
        } viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>`,

    buildWarningIcon: (classes?: string) =>
        `<svg ${
            classes ? `class="${classes}"` : ''
        } viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 0h24v24H0z" fill="none"></path><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path></svg>`,

    buildAlertInfoIcon: (classes?: string) =>
        `<svg ${
            classes ? `class="${classes}"` : ''
        } width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0 0h24v24H0z" fill="none"></path><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path></svg>`,

    buildSearchIcon: (classes?: string) =>
        `<svg ${
            classes ? `class="${classes}"` : ''
        } width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 19.5L16.78 15.78C17.98 14.35 18.71 12.52 18.71 10.51C18.71 5.99 15.03 2.31 10.51 2.31C5.99 2.31 2.31 5.99 2.31 10.51C2.31 15.03 5.99 18.71 10.51 18.71C12.52 18.71 14.35 17.98 15.78 16.78L19.5 20.5C19.64 20.64 19.82 20.71 20 20.71C20.18 20.71 20.36 20.64 20.5 20.5C20.78 20.22 20.78 19.77 20.5 19.5ZM3.73 10.51C3.73 6.77 6.77 3.73 10.51 3.73C14.25 3.73 17.29 6.77 17.29 10.51C17.29 14.25 14.25 17.29 10.51 17.29C6.77 17.29 3.73 14.25 3.73 10.51Z" fill="currentColor"></path>
        </svg>`,
    buildHomeIcon: (classes?: string) =>
        `
        <svg ${ classes ? `class="${classes} header-footer-icon"` : ''}
        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.37 9.39004L20.37 8.19004L13.4 4.01004C12.54 3.50004 11.47 3.49004 10.61 4.01004L3.63999 8.19004L1.63999 9.39004C1.29999 9.59004 1.18999 10.03 1.39999 10.36C1.59999 10.7 2.03999 10.8 2.36999 10.6L3.28999 10.05V18C3.28999 19.49 4.41 20.71 5.77999 20.71H18.22C19.59 20.71 20.71 19.49 20.71 18V10.05L21.63 10.6C21.74 10.67 21.87 10.7 21.99 10.7C22.23 10.7 22.47 10.58 22.6 10.36C22.8 10.02 22.69 9.59004 22.36 9.39004H22.37ZM10.71 19.29V15C10.71 14.84 10.84 14.71 11 14.71H13C13.16 14.71 13.29 14.84 13.29 15V19.29H10.71ZM19.29 18C19.29 18.71 18.81 19.29 18.22 19.29H14.71V15C14.71 14.06 13.94 13.29 13 13.29H11C10.06 13.29 9.28999 14.06 9.28999 15V19.29H5.77999C5.19 19.29 4.70999 18.71 4.70999 18V9.20004L11.34 5.22004C11.75 4.97004 12.26 4.97004 12.67 5.22004L19.3 9.20004V18H19.29Z" fill="#001333"/>
        </svg>
        `,
    buildEventAvailableIcon: (classes?: string) =>
        `
        <svg
            ${
            classes ? `class= "${classes}"` : ''
            }
            width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 3.29004H16.71V2.00004C16.71 1.61004 16.39 1.29004 16 1.29004C15.61 1.29004 15.29 1.61004 15.29 2.00004V3.29004H8.71004V2.00004C8.71004 1.61004 8.39004 1.29004 8.00004 1.29004C7.61004 1.29004 7.29004 1.61004 7.29004 2.00004V3.29004H7.00004C4.40004 3.29004 2.29004 5.40004 2.29004 8.00004V16C2.29004 18.6 4.40004 20.71 7.00004 20.71H17C19.6 20.71 21.71 18.6 21.71 16V8.00004C21.71 5.40004 19.6 3.29004 17 3.29004ZM20.29 16C20.29 17.81 18.81 19.29 17 19.29H7.00004C5.19004 19.29 3.71004 17.81 3.71004 16V8.00004C3.71004 6.19004 5.19004 4.71004 7.00004 4.71004H7.29004V6.00004C7.29004 6.39004 7.61004 6.71004 8.00004 6.71004C8.39004 6.71004 8.71004 6.39004 8.71004 6.00004V4.71004H15.29V6.00004C15.29 6.39004 15.61 6.71004 16 6.71004C16.39 6.71004 16.71 6.39004 16.71 6.00004V4.71004H17C18.81 4.71004 20.29 6.19004 20.29 8.00004V16Z" fill="#001333"/>
            <path d="M11.14 16.71C10.93 16.71 10.73 16.62 10.59 16.45L8.45004 13.88C8.20004 13.58 8.24004 13.13 8.54004 12.88C8.84004 12.63 9.29004 12.67 9.54004 12.97L11.06 14.8L14.39 9.61004C14.6 9.28004 15.04 9.18004 15.37 9.40004C15.7 9.61004 15.8 10.05 15.58 10.38L11.72 16.38C11.6 16.57 11.39 16.69 11.17 16.7C11.16 16.7 11.14 16.7 11.13 16.7L11.14 16.71Z" fill="#001333"/>
        </svg>
        `,
    buildFavoriteOutlineIcon: (classes?: string) =>
        `<svg
            ${ classes ? `class= "${classes}"` : '' }
            width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20.6399C11.73 20.6399 11.46 20.5999 11.21 20.5099C6.99004 19.0999 2.29004 14.0299 2.29004 8.99993C2.29004 5.31993 4.61004 3.55993 6.59004 3.17993C8.41004 2.82993 10.62 3.44993 12 5.47993C13.37 3.44993 15.59 2.82993 17.41 3.17993C19.4 3.55993 21.71 5.31993 21.71 8.99993C21.71 14.0199 17.01 19.0999 12.79 20.5099C12.53 20.5999 12.27 20.6399 12 20.6399ZM7.56004 4.50993C7.32004 4.50993 7.09004 4.52993 6.86004 4.57993C5.34004 4.86993 3.71004 6.18993 3.71004 8.99993C3.71004 13.2899 7.91004 17.9099 11.66 19.1599C11.88 19.2299 12.12 19.2299 12.34 19.1599C16.09 17.9099 20.29 13.2899 20.29 8.99993C20.29 6.18993 18.66 4.86993 17.14 4.57993C15.57 4.27993 13.57 4.98993 12.66 7.26993C12.44 7.80993 11.56 7.80993 11.34 7.26993C10.56 5.31993 8.98004 4.51993 7.56004 4.51993V4.50993Z" fill="#001333"/>
            </svg>
        `,
    buildSearchedForIcon: (classes?: string) =>
        `
        <svg ${
            classes ? `class= "${classes}"` : ''
        } width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5001 19.5001L16.7801 15.7801C17.9801 14.3501 18.7101 12.5201 18.7101 10.5101C18.7101 5.99006 15.0301 2.31006 10.5101 2.31006C5.99006 2.31006 2.31006 5.99006 2.31006 10.5101C2.31006 15.0301 5.99006 18.7101 10.5101 18.7101C12.5201 18.7101 14.3501 17.9801 15.7801 16.7801L19.5001 20.5001C19.6401 20.6401 19.8201 20.7101 20.0001 20.7101C20.1801 20.7101 20.3601 20.6401 20.5001 20.5001C20.7801 20.2201 20.7801 19.7701 20.5001 19.5001ZM3.73006 10.5101C3.73006 6.77006 6.77006 3.73006 10.5101 3.73006C14.2501 3.73006 17.2901 6.77006 17.2901 10.5101C17.2901 14.2501 14.2501 17.2901 10.5101 17.2901C6.77006 17.2901 3.73006 14.2501 3.73006 10.5101Z" fill="#001333"/>
        </svg>

        `,
};

const buildDesktopCareersLinkInnerHTML = (optimizeForSeo: boolean = false) => {
    return `<a
        id="careers-link--desktop"
        tabindex="-1"
        class="header-link"
        data-kmx-analytics="prop5=Header-More"
        href="${links.careers.href}"
        ${optimizeForSeo ? 'rel="nofollow"' : ''}
        >${links.careers.text}</a>`;
};

export const content = {
    CLASSNAMES: {
        hidden: 'hidden',
        visible: 'visible',
        bodyScrollLock: 'body-scroll-lock'
    },
    HEADER: {
        id: 'header',
        navRight: {
            class: 'header-nav-right',
            loggedInClass: 'header-nav-right--logged-in'
        }
    },
    FOOTER: {
        id: 'footer'
    },
    FOOTER_COPYRIGHT: {
        id: 'footer-copyright-year'
    },
    MOBILE_NAV: {
        body: {
            class: 'header-drawer-body'
        },
        menuId: 'header-nav-menu',
        menuClass: 'header-drawer',
        drawer: {
            defaultClass: 'header-drawer',
            openClass: 'header-drawer--open'
        },
        focusStartId: 'header-drawer-focus-start'
    },
    MORE_LINKS: {
        sectionClass: 'header-helpful-links-section',
        button: {
            id: 'header-helpful-links-button',
            icon: {
                class: 'header-helpful-links-button-icon',
                openClass: 'header-helpful-links-button-icon--open'
            }
        },
        menuId: 'header-helpful-links-menu',
        defaultMenu: {
            buildInnerHTML: (optimizeForSeo: boolean = false) => {
                return `<ul class="header-footer-menu-list" role="menu" tabindex="-1" aria-orientation="vertical">\
                    <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.service.href
                    }">${links.service.text}</a></li>\
                    <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.helpCenter.href
                    }" ${optimizeForSeo ? 'rel="nofollow"' : ''}>${links.helpCenter.text}</a></li>\
                    <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.whyCarMax.href
                    }" ${optimizeForSeo ? 'rel="nofollow"' : ''}>${links.whyCarMax.text}</a></li>\
                    <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.buyingOnline.href
                    }" ${optimizeForSeo ? 'rel="nofollow"' : ''}>${links.buyingOnline.text}</a></li>\
                    <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.researchEVGuide.href
                    }">${links.researchEVGuide.text}</a></li>\
                    <li class="header-footer-menu-list-item before-separator" role="menuitem" tabindex="-1"><a tabindex="-1" data-kmx-analytics="prop5=Header-More" class="header-link" href="${
                        links.maxcareService.href
                    }" ${optimizeForSeo ? 'rel="nofollow"' : ''}>${links.maxcareService.text}</a></li>\
                    <li role="separator"><hr class="header-footer-menu-divider" /></li>\
                    <li class="header-footer-menu-list-item after-separator header-link__careers-link" role="menuitem" tabindex="-1">${buildDesktopCareersLinkInnerHTML(
                        optimizeForSeo
                    )}</li>\
                    </ul>`;
            }
        },
        careersLink: {
            label: 'Search jobs at CarMax',
            href: 'https://careers.carmax.com/us/en/',
            desktop: {
                innerHTML: buildDesktopCareersLinkInnerHTML(),
                id: 'careers-link--desktop',
                class:
                    'header-footer-menu-list-item header-link__careers-link mobile-hidden tablet-hidden'
            }
        }
    },
    HEADER_SEARCH: {
        id: 'header-search-bar',
        activeClass: 'header-search-bar--active',
        input: {
            id: 'header-inventory-search'
        },
        menuId: 'header-search-bar-menu',
        formId: 'header-search-bar-form',
        autocompleteList: {
            id: 'header-search-bar-list',
            listItemClass: 'header-footer-menu-list-item',
            listItemRole: 'menuitem',
            listRole: 'menu',
            linkClass: 'menu-item-link',
            textClass: 'menu-item-text'
        }
    },
    HEADER_MY_STORE: {
        sectionClassNoStore: 'header-my-store-section-no-store',
        sectionClass: 'header-my-store-section',
        buttonId: 'header-my-store-button',
        buttonAlertClass: 'header-my-store-button-alert',
        buttonTextId: 'header-my-store-button-text',
        buttonSecondaryTextId: 'header-my-store-button-zipCode',
        storeStatusId: 'header-store-status-text',
        storeStatusTextId: 'store-status--text',
        storeStatusHoursId: 'store-status--status-hours',
        iconClass: 'header-footer-icon',
        menuId: 'header-my-store-menu',
        alertInfoIconContainerClass: 'header-alert-info-icon-container',
        alertInfoIconClass: 'header-alert-info-icon mobile-hidden',
        locationAlertIconContainerClass: 'header-footer-location-icon-alert',
        locationAlertCircleClass: 'header-footer-location-icon-alert-circle',
        storeSearchFormId: 'header-store-search-form'
    },
    FOOTER_MY_STORE: {
        sectionClass: 'footer-my-store-section',
        buttonId: 'footer-my-store-button',
        buttonAlertClass: 'footer-my-store-button-alert',
        buttonTextId: 'footer-my-store-button-text',
        iconClass: 'header-footer-icon',
        menuId: 'footer-my-store-menu',
        locationAlertIconContainerClass: 'header-footer-location-icon-alert',
        locationAlertCircleClass: 'header-footer-location-icon-alert-circle',
        storeSearchFormId: 'footer-store-search-form'
    },
    HEADER_FOOTER_FLYOUT_MENU: {
        storeHoursMenuClass: 'header-footer-my-store-details-store-hours-menu',
        storeHoursButtonClass: 'header-footer-my-store-details-store-hours-button'
    },
    MY_STORE_DETAILS: {
        addressClass: 'header-footer-my-store-details-address-link',
        getInnerHtml: (store: Store, availability: StoreAvailability, type: 'header' | 'footer') => {
            return getStoreDetailsHTML() + getStoreSearchHTML();
            function getStoreDetailsHTML() {
                const AddressLine2 = `${store.MailingCity}, ${store.StateAbbreviation} ${store.ZipCode}`;
                const storeStatus = new StoreStatus(store);
                const storeDistance = store.DistanceInMiles;

                const availabilityText = availability.IsOpen ? "Currently open" : "Currently closed";
                const alertMessage = availability.Alert?.message; // Nullable object
                const alertStatus = availability.Alert?.locationStatus;
                const alertStatusClosure = alertStatus == 'Closed' || isClosed(alertMessage);
                let statusText = "";

                // Order: Alert (abnormality) -> Holiday -> Regular open/closed
                if(alertMessage) {
                    statusText = getStoreStatusDisplay(alertMessage);
                }else if(storeStatus.statusText) {
                    statusText = storeStatus.statusText;
                }else {
                    statusText = availabilityText;
                }

                const seeCarsUrl = determineSeeCarsUrl(store);
                const zipCodeToDisplay = getUserEnteredZipCode() ?? store.ZipCode;

                let html = store.Id
                    ? `<div id="${type}-my-store-details" class="header-footer-my-store-details"><div class="header-footer-my-store-details-header">Your store for ${
                          zipCodeToDisplay
                      }:</div>\
                <div class="header-footer-my-store-details-store-name"><span>${
                    store.Name
                }<span aria-label="${storeDistance + " miles"}" class="kmx-typography-body2">${
                          storeDistance > 0 ? '(' + storeDistance + ' mi)' : ''
                      }</span></span><span></span></div>\
                <a id="my-store-details-btn" tabindex="0" data-kmx-analytics="prop5=Header-Location" ${MENU_DATA_ATTR.dialog}="${
                          MENU_DATA_ATTR.focusStart

                      }" class="header-footer-my-store-details-link" href="/stores/${
                          store.Id
                      }">See all store details</a>\
                <div class="header-footer-my-store-details-info-section">\
                    <div class="header-footer-my-store-details-address">${store.AddressLine1}<br>${AddressLine2}</div>\
                    ${`<button class="header-footer-my-store-details-store-hours-button" data-kmx-analytics="prop5=Header-Location">${
                        alertStatusClosure
                            ? `<div class="icon-wrapper">${icons.buildWarningIcon('warningIcon')}</div>`
                            : ''
                    }
                        <span class="store-status-text ${statusText.toLowerCase()}">${
                        statusText
                    }
                    ${alertStatusClosure ? "":    `</span><span class="store-status-hours"> ${storeStatus.hoursText}`}
                        </span> <span class="icon-wrapper">${icons.buildDropdownIcon('dropdownIcon')}</span></button>`}
                </div>\
                <div class="${content.HEADER_FOOTER_FLYOUT_MENU.storeHoursMenuClass}">${storeStatus.storeMenu}</div>
                <a rel="nofollow" tabindex="0" class="header-footer-my-store-details-inventory-link" data-kmx-analytics="prop5=Header-Location | searchInit" href="${seeCarsUrl}">
                    Shop cars at this store
                </a>\
                </div>`
                    : '';
                return html;
            }

            function getStoreSearchHTML() {
                const STORE_SEARCH_LABEL = 'Change your store';
                const STORE_SEARCH_PLACEHOLDER = '';
                let html = `
                    <div class="header-footer-store-search-bar">\
                    <form id="${type}-store-search-form" class="header-search-bar-form" role="search" id="${type}-store-search-form" onSubmit="event.preventDefault()">
                    <h6 id="${type}-store-search-form-heading" class="kmx-typography-h6">${STORE_SEARCH_LABEL}</h6>\
                    <fieldset class="header-search-bar-form-fieldset">
                            <div class="header-footer-store-search-bar-container">
                                <label for="${type}-store-search-form-input" class="header-footer-store-search-bar-input-label">Enter zip or state</label>\
                                <input
                                tabindex="0" ${
                                    store.Id ? '' : `${MENU_DATA_ATTR.dialog}="${MENU_DATA_ATTR.focusStart}"`
                                    }
                                    id="${type}-store-search-form-input" name="keyword" class="header-search-bar-input" type="search" placeholder="${STORE_SEARCH_PLACEHOLDER}" autocomplete="off" value=""
                                />
                                <div class="header-footer-store-search-bar-button-container">
                                    <button data-kmx-analytics="prop5=Header-Location" tabindex="0" ${MENU_DATA_ATTR.dialog}="${
                    MENU_DATA_ATTR.focusEnd
                }" id="${type}-store-search-button" aria-label="Search for CarMax stores." type="submit" class="header-footer-input-icon-button">\
                                    ${icons.buildSearchIcon('.header-footer-icon')}\
                                    </button>\
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>`;
                return html;
            }
        }
    },
    MY_PROFILE: {
        sectionClass: 'header-my-profile-section',
        buttonId: 'header-my-profile-button',
        menuId: 'header-my-profile-menu',
        authenticatedMenu: {
            innerHTML: `<ul class="header-footer-menu-list" role="menu" tabindex="-1" aria-hidden="true" aria-orientation="vertical">\
                <li class="header-footer-menu-list-item payment-button" role="menuitem" tabindex="-1"><a rel="nofollow" class="payment-link" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.makeAPayment.href
                }">${links.makeAPayment.text}</a></li>\
                <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.myDashboard.href
                }"><span class="icon-wrapper">${icons.buildHomeIcon('homeIcon')}</span>${links.myDashboard.text}</a></li>\
                <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.appointments.href
                }"><span class="icon-wrapper">${icons.buildEventAvailableIcon('homeIcon')}</span>${
                links.appointments.text
            }</a></li>\
                <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" class="header-link header-link--favorites" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.savedCars.href
                }"><span class="icon-wrapper">${icons.buildFavoriteOutlineIcon('homeIcon')}</span>${
                links.savedCars.text
            }</a></li>\
                <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1"><a tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.savedSearches.href
                }"><span class="icon-wrapper">${icons.buildSearchedForIcon('homeIcon')}</span>${
                links.savedSearches.text
            }</a></li>\
                <li role="separator"><hr class="header-footer-menu-divider"></li>\
                <li class="header-footer-menu-list-item header-footer-menu-list-item__delineated-link" role="menuitem" tabindex="-1"><div class="header-footer-menu-list-item"><a tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${
                    links.profileSettings.href
                }">${links.profileSettings.text}</a></div></li>\
                <li class="header-footer-menu-list-item" role="menuitem" tabindex="-1">\
                    <div class="header-footer-menu-list-item header-footer-menu-list-item__delineated-link">\
                        <a id="sign-out-link" tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${links.signOut.href}">\
                            ${links.signOut.text}
                        </a>\
                    </div>\
                </li>\
            </ul>
            `
        },
        unauthenticatedMenu: {
            innerHTML: `<ul class="header-footer-menu-list" role="menu" tabindex="-1" aria-hidden="true" aria-orientation="vertical">\
                <li class="header-footer-menu-list-item payment-button" role="menuitem" tabindex="-1"><a rel="nofollow" class="payment-link" data-kmx-analytics="prop5=Header-Profile" href="${links.makeAPayment.href}">${links.makeAPayment.text}</a></li>\
                <li class="header-footer-menu-list-item header-footer-menu-list-item__delineated-link" role="menuitem" tabindex="-1"><div class="header-footer-menu-list-item"><a tabindex="-1" class="header-link" data-kmx-analytics="prop5=Header-Profile" href="${links.signIn.href}">${links.signIn.text}</a></div></li>\
            </ul>`
        }
    },
    SAVED_CARS_BUTTON: {
        id: 'header-saved-cars-button',
        visibleClass: 'visible'
    },
    STORE_CHOOSER: {
        WRAPPER: {
            id: 'store-chooser-wrapper',
            class: 'store-chooser-wrapper',
            visibleClass: 'visible'
        },
        BACKGROUND: {
            class: 'store-chooser-background-modal'
        },
        MODAL: {
            id: 'store-chooser-modal',
            class: 'store-chooser-modal',
            role: 'dialog',
            HEADER: {
                id: 'store-chooser-modal_header',
                class: 'store-chooser-modal_header',
                TITLE: {
                    class: 'store-chooser-modal_header-title',
                    id: 'store-chooser-modal_header-title',
                    innerText: 'Select your store'
                },
                DESCRIPTION: {
                    class: 'hidden',
                    id: 'store-chooser-modal_header-description',
                    innerText:
                        'You can change your store in this dialog and have the carmax experience update accordingly.'
                },
                CLOSE: {
                    class: 'store-chooser-modal_header-close',
                    type: 'button',
                    ariaLabel: 'close',
                    ariaHidden: 'false',
                    innerHTML:
                            `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M13 12L19.5 5.50004C19.78 5.22004 19.78 4.77004 19.5 4.50004C19.22 4.23004 18.77 4.22004 18.5 4.50004L12 11L5.49998 4.50004C5.21998 4.22004 4.76998 4.22004 4.49998 4.50004C4.22998 4.78004 4.21998 5.23004 4.49998 5.50004L11 12L4.49998 18.5C4.21998 18.78 4.21998 19.23 4.49998 19.5C4.63998 19.64 4.81998 19.71 4.99998 19.71C5.17998 19.71 5.35998 19.64 5.49998 19.5L12 13L18.5 19.5C18.64 19.64 18.82 19.71 19 19.71C19.18 19.71 19.36 19.64 19.5 19.5C19.78 19.22 19.78 18.77 19.5 18.5L13 12Z" fill="#001333"/>
                            </svg>`
                }
            },
            FORM: {
                id: 'store-chooser-keyword-search-form',
                class: 'store-chooser-modal_search-form',
                visibleClass: 'visible',
                INPUT: {
                    id: 'store-chooser-keyword-input',
                    class: 'store-chooser-modal_search-form-input',
                    name: 'keyword',
                    placeholder: 'Search by state or zip'
                },
                BUTTON: {
                    class: 'store-chooser-modal_search-form-button',
                    innerHTML:
                        `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20.5 19.5001L16.78 15.7801C17.98 14.3501 18.71 12.5201 18.71 10.5101C18.71 5.99006 15.03 2.31006 10.51 2.31006C5.99 2.31006 2.31 5.99006 2.31 10.5101C2.31 15.0301 5.99 18.7101 10.51 18.7101C12.52 18.7101 14.35 17.9801 15.78 16.7801L19.5 20.5001C19.64 20.6401 19.82 20.7101 20 20.7101C20.18 20.7101 20.36 20.6401 20.5 20.5001C20.78 20.2201 20.78 19.7701 20.5 19.5001ZM3.73 10.5101C3.73 6.77006 6.77 3.73006 10.51 3.73006C14.25 3.73006 17.29 6.77006 17.29 10.5101C17.29 14.2501 14.25 17.2901 10.51 17.2901C6.77 17.2901 3.73 14.2501 3.73 10.5101Z" fill="#001333"/>
                        </svg>`,
                    type: 'submit',
                    ariaLabel: 'Set My Store',
                    ariaHidden: 'false'
                }
            },
            BODY: {
                id: 'store-chooser-modal-body',
                class: 'store-chooser-modal-body',
                loadingInnerHTML: `<div class="carmax-loading"><div class="carmax-loading-ring first-ring"></div><div class="carmax-loading-ring second-ring"></div><div class="carmax-loading-ring third-ring"></div><div class="carmax-loading-ring fourth-ring"></div></div>`,
                noMatchesFoundInnerHtml: `<div class="store-chooser-modal_no-matches"><p class="store-chooser-modal_no-matches-text">No matches found</p></div>`,
                LIST: {
                    class: 'store-chooser-modal_list',
                    STORE: {
                        class: 'store-chooser-modal_list-store',
                        itemInnerHTML: (
                            name: string,
                            distance: number,
                            street: string,
                            city: string,
                            state: string,
                            zip: string,
                            alertMessage: string | null,
                            hoursText: string,
                            showHours: boolean
                        ) => {
                            return `<div class='store-chooser-modal_list-store-info'>
                                        <div class='store-title'>
                                                <h4 class='store-title-name'>${name}</h4>
                                                ${
                                                    distance > 0
                                                        ? `<span aria-label="${distance + " miles"}" class='store-title-distance'>~${distance} mi</span>`
                                                        : ''
                                                }
                                        </div>
                                        <p class='store-address'>${street}<br>${city}, ${state} ${zip}</p>
                                        ${
                                            alertMessage
                                                ? `<p class='store-hours alert'>${icons.buildWarningIcon(
                                                      'warningIcon'
                                                  )}${alertMessage}</p>`
                                                : showHours
                                                ? `<p class='store-hours'> Open today ${hoursText}</p>`
                                                : ``
                                        }
                                    </div>`;
                        },
                        selectClass: 'store-chooser-modal_list-store-select',
                        selectGrandOpenClass:
                            'store-chooser-modal_list-store-select-grand-open',
                        selectGrandOpenInnerHTML: `<svg class="grand-open-store-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24" aria-hidden="true"><path d="M23 8c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v6c0 .6-.4 1-1 1zM19 9c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4 4c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM19 13h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" fill="#db187a" /></svg>Opening Soon`,
                        selectSelectedClass:
                            'store-chooser-modal_list-store-select-selected',
                        selectSelectedInnerHTML: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.79026 18.71C9.58026 18.71 9.38026 18.62 9.24026 18.45L4.95026 13.31C4.70026 13.01 4.74026 12.56 5.04026 12.31C5.34026 12.06 5.79026 12.1 6.04026 12.4L9.71026 16.8L16.9003 5.60998C17.1103 5.27998 17.5503 5.17998 17.8803 5.39998C18.2103 5.60998 18.3103 6.04998 18.0903 6.37998L10.3803 18.38C10.2603 18.57 10.0503 18.69 9.83026 18.7C9.82026 18.7 9.80026 18.7 9.79026 18.7V18.71Z" fill="#006600"/>
                                                </svg>
                                                <div class="store-chooser-modal_list-store-select-selected-text"> My store </div>`,
                        selectButtonClass:
                            'store-chooser-modal_list-store-select-button kmx-button kmx-button--tertiary',
                        selectButtonInnerText: 'Set as my store',
                        selectButtonType: 'button',
                        selectButtonAriaLabel: 'set store',
                        selectButtonAriaHidden: 'false',
                        allStoreLinkClass: 'store-chooser-modal_list-store-all-link',
                        allStoreLinkText: 'See all stores',
                        allStoreLinkHref: '/stores'
                    }
                },
                ERROR: {
                    class: 'store-chooser-modal_error',
                    innerHTML: `<svg class="store-chooser-modal_error-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M0 0h24v24H0z" fill="none"></path><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
                        </svg>
                        <div class="store-chooser-modal_error-text">
                            Try searching again<br>by ZIP or State
                        </div>`
                }
            }
        },
        EVENT_NAMES: {
            headerKeywordInput: 'store-chooser-header-input',
            footerKeywordInput: 'store-chooser-footer-input'
        }
    },
    OPTIMIZED_SEARCH: [
        { listItemUrl: '/cars/sport-utilities', listItemText: 'SUVs' },
        { listItemUrl: '/cars/plug-in-hybrid/electric/hybrid', listItemText: 'Hybrids & EVs' },
        { listItemUrl: '/cars/pickup-trucks', listItemText: 'Trucks' },
        { listItemUrl: '/cars/minivans-and-vans', listItemText: 'Vans & Minivans' },
        { listItemUrl: '/articles/most-reliable-cars', listItemText: 'Most Reliable Cars — Article' }
    ]
};
